import {
    createContext
} from "react";
import type {
    TooltipDelaysType
} from "./type";

export const TooltipDelayContext = createContext<TooltipDelaysType | null>(null);
